<template>
    <TransitionRoot :show="sidebarOpen" as="template">
        <Dialog as="div" class="relative z-40 md:hidden" @close="$emit('toggleSidebar', false)">
            <TransitionChild
                as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
                enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-600 bg-opacity-75"/>
            </TransitionChild>

            <div class="fixed inset-0 z-40 flex">
                <TransitionChild
                    as="template" enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full" enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                    leave-to="-translate-x-full">
                    <DialogPanel class="relative flex w-full max-w-xs flex-1 flex-col bg-gray-100 px-3">
                        <TransitionChild
                            as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                            enter-to="opacity-100" leave="ease-in-out duration-300"
                            leave-from="opacity-100" leave-to="opacity-0">
                            <div class="absolute top-0 right-0 -mr-12 pt-2">
                                <button
                                    class="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                    type="button"
                                    @click="$emit('toggleSidebar', false)">
                                    <span class="sr-only">Close sidebar</span>
                                    <XMarkIcon aria-hidden="true" class="h-6 w-6 text-white"/>
                                </button>
                            </div>
                        </TransitionChild>
                        <div class="h-0 flex-1 overflow-y-auto pt-2 pb-4">
                            <Logo/>
                            <nav class="mt-5 space-y-1 px-2">
                                <SidebarNavItem
                                    v-for="item in navigation" :key="item.name"
                                    :item="item"/>
                                <SidebarSecondaryLinks
                                    :account-navigation="accountNavigation"
                                    :secondary-navigation="secondaryNavigation"/>
                            </nav>
                        </div>

                        <SidebarAccount/>
                    </DialogPanel>
                </TransitionChild>
                <div class="w-14 flex-shrink-0">
                    <!-- Force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import SidebarNavItem from '@/Layouts/Legacy/Partials/SidebarNavItem.vue';
import {XMarkIcon} from '@heroicons/vue/24/outline/esm/index.js';
import Logo from '@/Layouts/Legacy/Partials/Logo.vue';
import SidebarAccount from '@/Layouts/Legacy/Partials/SidebarAccount.vue';
import SidebarSecondaryLinks from '@/Layouts/Legacy/Partials/SidebarSecondaryLinks.vue';

export default {
    components: {
        SidebarAccount,
        Logo,
        Dialog,
        TransitionRoot,
        TransitionChild,
        DialogPanel,
        SidebarNavItem,
        SidebarSecondaryLinks,
        XMarkIcon,
    },

    props: {

        sidebarOpen: {
            type: Boolean,
            required: true,
        },

        navigation: {
            required: true,
            type: Object,
        },
        secondaryNavigation: {
            required: true,
            type: Object,
        },
        accountNavigation: {
            required: true,
            type: Object,
        }
    }
};
</script>
